/**
 * Enum indicating if a scripting field is a regular field or a grid
 */
export enum FormScriptingFieldType {
  Field,
  Grid
}
